<router-outlet *ngIf="isNotMobile$ | async"></router-outlet>

<div *ngIf="isMobile$ | async" fxLayout="column" fxLayoutAlign="center center" class="mobile-not-supported">
  <img class="word-mark" src="/assets/logo/dark/logo-stroke.svg" alt="" />
  <div class="text-404">To access BudSense, please sign-in from a desktop, laptop or tablet device.</div>
</div>
